import { configureStore } from '@reduxjs/toolkit';



import { JamboReducers, JamboMidllWares } from '../store/store';
import productReducer from './product/slice';
import reducer from './base/baseSlice';
import cart from './cart/cartSlice';
import notifications from './notifications/notificationSlice';
import agency from './agency/agencySlice';
import productType from './productType/slice';
import category from './category/slice';
import attribute from './attributes/slice';
import order from './order/slice';
import slider from './slider/slice';
import blog from './blog/slice';
import tag from './tag/slice';
import user from './user/userSlice';
import admin from './admin/adminSlice';
import notice from './notice/slice';
import discountCode from './discountCode/slice';

export const jamboStore = configureStore({
    reducer: {
        ...JamboReducers,
        ...productReducer,
        ...reducer,
        ...cart,
        ...notifications,
        ...agency,
        ...productType,
        ...category,
        ...attribute,
        ...order,
        ...slider,
        ...blog,
        ...tag,
        ...user,
        ...notice,
        ...discountCode,
        ...admin
    },
    middleware: (getDefaults) =>
        getDefaults(
            {
            serializableCheck: {
                ignoredPaths: ['notification'],
                // ignoredActionPaths: ['meta.arg', 'payload.file'],
                ignoredActions: ['notification/addSnackbar', 'notification/closeSnackbar'],
            },
            immutableCheck: {
                ignoredPaths: ['notification'],
            },
        }
        ).concat(JamboMidllWares),
});

// upload / addMediaUpload;
